interface CheckboxWithHoverActionProps {
  checked: boolean;
  ariaLabel: string;
  isHovered: boolean;
  onActionClick: () => void;
  actionLabel: string;
}

// Renders a disabled checked checkbox cell that reveals an action button overlay on hover.
export function CheckboxWithHoverAction({
  checked,
  ariaLabel,
  isHovered,
  onActionClick,
  actionLabel,
}: CheckboxWithHoverActionProps) {
  return (
    <td className="size-px whitespace-nowrap px-3 py-4 relative">
      <input
        type="checkbox"
        checked={checked}
        disabled
        className="shrink-0 border-border rounded-sm text-primary focus:ring-primary checked:border-primary bg-surface cursor-not-allowed"
        aria-label={ariaLabel}
      />
      <div
        className={`absolute inset-0 flex items-center px-3 ${
          isHovered ? 'opacity-100' : 'opacity-0'
        } transition-opacity duration-200`}
      >
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onActionClick();
          }}
          className="py-1.5 px-2 inline-flex items-center gap-x-1.5 text-xs font-medium rounded-lg border border-border bg-surface text-onsurface shadow-2xs hover:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-surface-darker"
        >
          {actionLabel}
        </button>
      </div>
    </td>
  );
}
